import type { JSXElement } from "solid-js"

export default function TextMuted (text : JSXElement) {
  return <span class="text-muted">{text}</span>
}
